export default __webpack_public_path__ + "9200edd909e1d04659a66b5bf3e16604.png";